/*
 * Popup
 */
function InitPopups() {
  class Popup {
    constructor(el) {
      this.query(el);
      this.events();
    }

    query(el) {
      this.popup = el;

      if (this.popup.parentElement !== document.body) {
        document.body.appendChild(this.popup);
      }

      this.closeButton = el.querySelector('.popup__close');

      // 🔥 ищем любой возможный контент внутри
      this.inner =
          el.querySelector('.popup__inner') ||
          el.querySelector('.video-showcase__popup-embed') ||
          el.firstElementChild;

      this.buttons = [...document.querySelectorAll(`a[href="#${el.id}"]`)];
      this.previousBodyStyles = {};
      this.previousHtmlOverflow = '';
      this.previousHtmlScrollBehavior = '';
      this.scrollY = 0;
    }

    lockBody() {
      this.scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      this.previousHtmlOverflow = document.documentElement.style.overflow;
      this.previousHtmlScrollBehavior = document.documentElement.style.scrollBehavior;
      this.previousBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow,
      };

      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    unlockBody() {
      const restoreScroll = () => {
        window.scrollTo(0, this.scrollY);
      };

      document.documentElement.style.overflow = this.previousHtmlOverflow;
      document.body.style.position = this.previousBodyStyles.position || '';
      document.body.style.top = this.previousBodyStyles.top || '';
      document.body.style.left = this.previousBodyStyles.left || '';
      document.body.style.right = this.previousBodyStyles.right || '';
      document.body.style.width = this.previousBodyStyles.width || '';
      document.body.style.overflow = this.previousBodyStyles.overflow || '';
      restoreScroll();

      window.requestAnimationFrame(() => {
        restoreScroll();
        document.documentElement.style.scrollBehavior = this.previousHtmlScrollBehavior;
      });
    }

    clearHash() {
      if (window.location.hash === `#${this.popup.id}`) {
        window.history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search
        );
      }
    }

    playVideo() {
      const video = this.popup.querySelector('video');

      if (video) {
        video.play().catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });

        return;
      }

      this.playIframeVideo();
    }

    pauseVideo() {
      const video = this.popup.querySelector('video');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      this.pauseIframeVideo();
    }

    playIframeVideo() {
      const iframe = this.popup.querySelector('iframe');

      if (!iframe) {
        return;
      }

      if (!iframe.dataset.originalSrc) {
        iframe.dataset.originalSrc = iframe.src;
      }

      iframe.src = this.addAutoplayToUrl(iframe.dataset.originalSrc);
    }

    pauseIframeVideo() {
      const iframe = this.popup.querySelector('iframe');

      if (!iframe || !iframe.dataset.originalSrc) {
        return;
      }

      iframe.src = iframe.dataset.originalSrc;
    }

    addAutoplayToUrl(url) {
      const separator = url.includes('?') ? '&' : '?';

      if (url.includes('autoplay=1')) {
        return url;
      }

      return `${url}${separator}autoplay=1&rel=0&playsinline=1`;
    }

    open(event) {
      if (event) {
        event.preventDefault();
      }

      this.lockBody();
      this.clearHash();

      if (!this.popup.open) {
        this.popup.showModal();
      }

      this.playVideo();
    }

    close() {
      this.pauseVideo();

      if (this.popup.open) {
        if (document.activeElement && this.popup.contains(document.activeElement)) {
          document.activeElement.blur();
        }

        this.popup.close();
      }
    }

    events() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => this.open(event));
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      // 🔥 КЛИК ВНЕ КОНТЕНТА = ЗАКРЫТИЕ (РАБОТАЕТ ВСЕГДА)
      this.popup.addEventListener('click', (event) => {
        if (!this.inner) return;

        // если клик НЕ внутри контента и не по крестику
        if (!this.inner.contains(event.target) && !event.target.closest('.popup__close')) {
          this.close();
        }
      });

      this.popup.addEventListener('close', () => {
        this.pauseVideo();
        this.unlockBody();
        this.clearHash();
      });
    }
  }

  window.popups = [];

  document.querySelectorAll('dialog').forEach((el) => {
    window.popups.push(new Popup(el));
  });

  window.addEventListener('load', () => {
    const hash = window.location.hash;

    if (hash && hash.startsWith('#')) {
      const popup = document.querySelector(hash);
      const popupInstance = window.popups.find((item) => item.popup === popup);

      if (popupInstance) {
        setTimeout(() => popupInstance.open(), 150);
      }
    }
  });
}

export default InitPopups;
